export const actions = {
  async register(state, data) {
    const res = await this.$axios.post('/register', data)
    return res
  },
  async logout(state) {
    const res = await this.$axios.post('/logout')
    return res
  },
  async checkToken(state) {
    let res = null

    res = await this.$axios.get('/verify')
    return res
  },
}
